import { render, staticRenderFns } from "./SingleFileUploadHandlerSidebar.vue?vue&type=template&id=d59017c4"
import script from "./SingleFileUploadHandlerSidebar.vue?vue&type=script&lang=js"
export * from "./SingleFileUploadHandlerSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports